<!-- eslint-disable max-lines -->
<template>
    <paper class="dispatch">
        <div v-if="isDetail">
            <el-button @click="back">返 回</el-button>
            <el-table :data="detailData" border style="width: 100%">
                <el-table-column
                    v-for="item in tableColumn"
                    :key="item.prop"
                    :prop="item.prop"
                    :label="item.label"
                    width="180"
                >
                </el-table-column>
            </el-table>
        </div>
        <m-pane
            ref="tablePage"
            v-else
            class="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :initSearchInfo="initSearchInfo"
            :currentPage="currentPage"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @searchChange="searchChange"
            @selectChange="selectChange"
            @row-db-click="rowDBclick"
            :searchTotalTitle="config.searchTotalTitle"
            searchId="test"
            pageID="test"
        >
            <div slot="table-module-btn">
                <reportExport
                    #default="{ submit }"
                    reportCode="REPORT-LSP-LMS-TASK"
                >
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="'05020002'">
                            <el-button
                                icon="icon-daochu"
                                size="mini"
                                @click="exportFile(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <!-- <el-button type="primary">发布抢单</el-button> -->
                <el-button type="primary" @click="line" v-has="'05020001'"
                    >排车调度</el-button
                >
                <span class="dispatch-collect">
                    数量：{{ collectEttaQuantity }}；&nbsp; 体积(方)：{{
                        collectEttaVolume
                    }}；&nbsp; 重量(KG)： {{ collectEttaWeight }}
                </span>
                <el-button type="primary" @click="loadTruckSort"
                    >装车排序</el-button
                >
            </div>
        </m-pane>
        <el-dialog
            class="dispatchArrangeCarDialog"
            title="排车调度"
            :visible.sync="lineVisible"
            width="80%"
            @close="handleLineClose"
        >
            <el-form
                ref="form"
                inline
                :model="ruleForm"
                label-position="right"
                label-width="100px"
                :rules="rules"
            >
                <el-row :gutter="10">
                    <el-col :span="6">
                        <el-form-item label="承运商">
                            <el-input
                                v-model="ruleForm.etdoCarrierName"
                                disabled
                                style="width: 180px"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="6">
                        <el-form-item label="直通宝标识" prop="etdoLtlFlag">
                            <otpSelect
                                style="width: 180px"
                                :optionNum="'SYS_TMS_ZTB_FLAG'"
                                :mValue="ruleForm.etdoLtlFlag"
                                @getSelectValue="getSelectValue"
                                :prop="'etdoLtlFlag'"
                            ></otpSelect>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="6">
                        <el-form-item label="车牌号" prop="etdoVehicleCard">
                            <otpAdvance
                                style="width: 180px"
                                :mValue="ruleForm.etdoVehicleCard"
                                :formData="prefixParams"
                                @getAdvanceValue="getAdvanceValue"
                                :params="config.viewBillBasicData.carNumber"
                            >
                            </otpAdvance>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="车型">
                            <el-input
                                v-model="ruleForm.etdoEquipmentName"
                                disabled
                                style="width: 180px"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="司机" prop="etdoMainDriver">
                            <otpAdvance
                                style="width: 180px"
                                :mValue="ruleForm.etdoMainDriver"
                                :formData="prefixParams"
                                @getAdvanceValue="getAdvanceValue"
                                :params="config.viewBillBasicData.driverLists"
                            >
                            </otpAdvance>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item
                            label="联系方式"
                            prop="etdoMainDriverContactWay"
                        >
                            <el-input
                                v-model="ruleForm.etdoMainDriverContactWay"
                                disabled
                                style="width: 180px"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="运输方式" prop="transportation">
                            <otpSelect
                                style="width: 180px"
                                :mValue="ruleForm.transportation"
                                :optionNum="'SYS_TMS_TRANSPORT_TYPE'"
                                @getSelectValue="getSelectValue"
                                :prop="'transportation'"
                            ></otpSelect>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item
                            label="预计到车时间"
                            prop="etdoBesArriveDate"
                        >
                            <el-date-picker
                                style="width: 180px"
                                v-model="ruleForm.etdoBesArriveDate"
                                type="datetime"
                                placeholder="预计到车时间"
                                default-time="23:59:59"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="结付方式">
                            <otpSelect
                                style="width: 180px"
                                :optionNum="'SYS_TMS_PAY_METHOD'"
                                :mValue="ruleForm.etdoPayMethod"
                                @getSelectValue="getSelectValue"
                                :prop="'etdoPayMethod'"
                            >
                            </otpSelect>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="备注">
                            <el-input
                                v-model="ruleForm.etdoRemark"
                                style="width: 180px"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="E6Gps设备号">
                            <el-input
                                v-model="ruleForm.etdoE6Devicename"
                                style="width: 180px"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="发运类型" prop="shippingType">
                            <otpSelect
                                :optionNum="'LSP_SHIPPING_TYPE'"
                                :mValue="ruleForm.shippingType"
                                @getSelectValue="getSelectValue"
                                placeholder="请选择发运类型"
                                :prop="'shippingType'"
                            ></otpSelect>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" v-if="ruleForm.shippingType === '10'">
                        <el-form-item label="是否直通宝转运" prop="etdoLtlFlag">
                            <el-select v-model="ruleForm.etdoLtlFlag">
                                <el-option label="是" value="10"></el-option>
                                <el-option label="否" value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button
                    @click="
                        () => {
                            this.handleLineClose()
                        }
                    "
                    >取 消</el-button
                >
                <el-button
                    type="primary"
                    @click="handleLineChange"
                    :loading="saveLoading"
                    >保 存</el-button
                >
            </span>
        </el-dialog>

        <el-dialog
            title="请填写装车排序"
            width="20%"
            top="10%"
            :visible.sync="loadTruckSortDialogVisible"
            :close-on-click-modal="false"
            :before-close="handleCloseLoadTruckSortDialogVisible"
            class="loadTruckSort"
        >
            <el-input
                autocomplete="off"
                v-model.number="loadingSeq"
                oninput="value = value.replace(/[^\d]+$/g, '')"
                @blur="loadingSeq = $event.target.value"
                placeholder="请填写装车排序"
                maxlength="3"
                clearable
            ></el-input>

            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseLoadTruckSortDialogVisible"
                    >取 消</el-button
                >
                <el-button
                    type="primary"
                    @click="handleSave"
                    :loading="loadingBtn"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import mPane from '@/components/supplierPanel';
import config from './config.js';
import {
    getList,
    getEtTaskMaterielItem,
    getEtTaskItemByAssighNos,
    saveEtDispatchOrder,
    loadDistrictKeyData,
    getCarTypeApi,
    lspLoadingSeq,
    checkCarNameNetItemApi,
    shippingTypeData
} from '../../api/dispatchManage';
import dayjs from 'dayjs';
import tableColumn from './tableColumn';
import otpSelect from '@/components/lots/otpSelect';
import otpAdvance from '@/components/lots/otpAdvance';
import reportExport from '@/components/lots/reportExportPlugin';
import common from '../../common/common';
import { maxDay } from '@/modules/transport/tms/common/common';
import { mapGetters } from 'vuex';
const { getSessionKey, initSessionData } = common;
const ettaCarrierIssued = 10;
const isCarrier = 'N';
const ettaStatus = '00';
export default {
    name: 'dispatch',
    components: { paper, mPane, otpSelect, otpAdvance, reportExport },
    created () {
        this.insertSearchItem();
        this.initRouter();
    },
    activated () {
        this.initRouter(true);
    },
    mounted () {
        initSessionData([
            'SYS_LMDM_PRIOR_LEVEL',
            'SYS_TRANSPORT_TASK_STATUS',
            'SYS_TMS_TRANSPORT_TYPE',
            'SYS_SUPPLIER_YES_NO'
        ]);
        // this.$refs.tablePage.$refs.searchList.onSearchChange();
    },
    computed: {
        ...mapGetters(['supplier', 'user', 'currentTenant'])
    },
    data () {
        return {
            dialogLoading: { close: () => { } }, // 弹框loading实例
            prefixParams: {
                supplierCode: '',
                routeNoList: []
            }, // 车牌号 和 司机 高级弹框前置搜索条件
            collectEttaQuantity: 0,
            collectEttaVolume: 0,
            collectEttaWeight: 0,
            loadingSeq: 1, // 装车排序 默认为1
            initSearchInfo: {}, // 用于设置初始默认值
            config,
            totalData: [], // table数据
            pageTotal: 0, // 总条数
            loading: false, // table的loading状态
            currentPage: 1, // 当前页数
            pageSize: 10, // 每页数量
            searchData: {}, // 搜索的对象结果
            isDetail: false, // 双击的详情页
            detailData: [], // 详情页table
            tableColumn, // 详情页table头部
            selectArray: [], // 已选项
            lineVisible: false, // 排车调度弹窗
            loadTruckSortDialogVisible: false, // 装车排序弹窗
            saveLoading: false, // 保存按钮loading
            loadingBtn: false, //  装车排序确认按钮loading
            ruleForm: {
                etdoCarrierName: '', // 承运商名字
                etdoCarrierCode: '', // 承运商编码
                etdoVehicleCard: '', // 车牌号
                etdoEquipmentName: '', // 车型
                etdoMainDriver: '', // 司机
                etdoMainDriverContactWay: '', // 联系方式
                transportation: '', // 运输方式
                etdoBesArriveDate: '', // 预计到车时间
                etdoPayMethod: '',
                etdoRemark: '',
                etdoE6Devicename: '',
                shippingType: '', // 发运类型
                etdoLtlFlag: '' // 直通宝转运
            },
            exportParams: {},
            isFirstSearch: true,
            rules: {
                // etdoLtlFlag: [
                //     { required: true, message: '请选择直通宝标识', trigger: 'change' }
                // ],
                etdoVehicleCard: [
                    { required: true, message: '请输入车牌号', trigger: 'change' }
                ],
                etdoMainDriver: [
                    { required: true, message: '请输入司机', trigger: 'change' }
                ],
                etdoMainDriverContactWay: [
                    { required: true, message: '请输入联系方式', trigger: 'change' }
                ],
                transportation: [
                    { required: true, message: '请选择运输方式', trigger: 'change' }
                ],
                etdoBesArriveDate: [
                    { required: true, message: '请选择预计到车时间', trigger: 'change' }
                ],
                shippingType: [
                    { required: true, message: '请选择发运类型', trigger: 'change' }
                ]
            }
        };
    },
    methods: {
        fullLoading (status = true) {
            this.dialogLoading.close();
            if (status) {
                this.dialogLoading = this.$loading({
                    target: '.dispatchArrangeCarDialog > div',
                    background: 'rgba(255, 255, 255, .7)'
                });
            } else {
                this.dialogLoading.close();
            }
        },
        insertSearchItem () {
            const user = {
                name: '片区责任人',
                value: 'ettaPersonZone',
                type: 'input',
                disabled: true,
                unfold: true,
                span: 2,
                data: this.user.userName
            };
            const area = {
                name: '片区',
                value: 'ettaZoneCode',
                type: 'select',
                span: 3,
                unfold: true,
                options: []
            };
            this.config.searchList.searchTxt.splice(3, 0, user, area);
            // 获取片区下拉框数据
            loadDistrictKeyData({ userName: this.user.userCode.toLocaleLowerCase() }).then(res => {
                if (res) {
                    area.options = res.data.map(item => {
                        return { label: item.DISTRICT_NAME, value: item.DISTRICT_CODE };
                    });
                }
            });
        },
        initRouter (isCache) {
            if (this.$route.query.ettaStatus) {
                this.initSearchInfo = {
                    ettaStatus: this.$route.query.ettaStatus
                };
                this.$router.replace(this.$route.path);
                this.$nextTick(() => {
                    this.$refs.tablePage.$refs.searchList.onSearchChange();
                });
            }
            // if (isCache) {
            //     this.$refs.tablePage.$refs.searchList.onSearchChange();
            // }
        },
        _validateSearchParams (data) {
            if (!data.createTimeFrom) {
                return '创建日期不能为空！';
            }
            const beginDate = dayjs(data.createTimeFrom).valueOf() || 0;
            const endDate = dayjs(data.createTimeTo).valueOf() || 0;
            const differenceValue = endDate - beginDate;
            if (differenceValue > maxDay) {
                return '按时间查询或导出时，时间跨度不可超过一个月！';
            }
        },
        _getList (pageNo = 1) {
            const msg = this._validateSearchParams(this.searchData);
            if (msg) return this.$message.warning(msg);
            this.loading = true;
            const {
                SYS_TRANSPORT_TASK_STATUS,
                SYS_LMDM_PRIOR_LEVEL,
                SYS_TMS_TRANSPORT_TYPE,
                SYS_SUPPLIER_YES_NO,
                ETTA_BUSINESS_TYPE
            } = sessionStorage;
            this.exportParams = {
                ettaCarrierEbcuCode: this.supplier.supplierCode,
                ettaCarrierIssued,
                isCarrier,
                ettaStatus,
                ...this.searchData
            };
            delete this.exportParams.ettaJoinElsNos;
            getList({
                pageNo,
                pageSize: this.pageSize,
                ettaCarrierEbcuCode: this.supplier.supplierCode,
                ettaCarrierIssued,
                isCarrier,
                ettaStatus,
                ...this.searchData
            }).then((res) => {
                if (res && res.data && +res.code === 0) {
                    const { list, totalCount, pageNo } = res.data;
                    this.totalData = list.map(item => {
                        // 紧急程度
                        item.ettaLevelType = getSessionKey(item.ettaLevel, SYS_LMDM_PRIOR_LEVEL);
                        // 是否预约
                        item.ettaReservationType = getSessionKey(item.ettaReservation, SYS_SUPPLIER_YES_NO);
                        // 运输方式
                        item.ettaTranTypeNew = getSessionKey(item.ettaTranType, SYS_TMS_TRANSPORT_TYPE);
                        // C端业务类型
                        item.ettaBusinessTypeNew = getSessionKey(item.ettaBusinessType, ETTA_BUSINESS_TYPE);
                        // 运输单状态
                        item.ettaStatusType = getSessionKey(item.ettaStatus, SYS_TRANSPORT_TASK_STATUS);
                        // 是否供方预约
                        item.etIsSupllyAppointmentType = +item.etIsSupllyAppointment ? '是' : '否';
                        return item;
                    });
                    this.pageTotal = totalCount;
                    this.currentPage = +pageNo;
                }
                this.loading = false;
            });
        },
        _getEtTaskMaterielItem (id) {
            getEtTaskMaterielItem({
                etupEttaNo: id
            }).then(res => {
                if (res && +res.code === 0) {
                    this.detailData = res.data.data;
                }
            });
        },
        _getEtTaskItemByAssighNos () {
            this.fullLoading();
            getEtTaskItemByAssighNos(this.selectArray).then(res => {
                if (res && +res.code === 0) {
                    this.ruleForm.etdoCarrierName = res.data.data[0].ettaCarrierEbcuNameCn;
                    this.ruleForm.etdoCarrierCode = this.prefixParams.supplierCode = res.data.data[0].ettaCarrierEbcuCode;
                }
            }).finally(() => {
                this.fullLoading(false);
            });
        },
        _saveEtDispatchOrder () {
            this.$refs.form.validate(async (valid) => {
                if (!valid) {
                    this.$message.error('请正确填写表单!');
                    return false;
                } else {
                    this.saveLoading = true;
                    this.ruleForm.shippingType === '00' && await this.getCarType(this.ruleForm.etdoEquipmentType);
                    this.ruleForm.etdoBesArriveDate = dayjs(this.ruleForm.etdoBesArriveDate).format('YYYY-MM-DD HH:mm:ss');
                    saveEtDispatchOrder({
                        ...this.ruleForm,
                        etdoDispatcherName: this.supplier.supplierNameCn,
                        etdoProcurementChannel: this.supplier.transType,
                        ettaIds: this.selectArray.map(item => item.ettaId)
                    }).then(res => {
                        if (res) {
                            if (res.data.success) {
                                this.$message.success('提交成功!');
                                this.handleLineClose(true);
                            } else {
                                this.$message.error(res.data.messagesAsString);
                            }
                        } else {
                            this.$message.error(res.msg);
                        }
                        this.saveLoading = false;
                    });
                }
            });
        },
        async getCarType (etdoEquipmentType) {
            await getCarTypeApi({ carTypeParam: etdoEquipmentType }).then(async res => {
                if (res && +res.code === 0) {
                    if (res.data && res.data.messages[0] === '无车型') {
                        // 传入车牌号
                        await this.checkCarNameNetItem(this.ruleForm.etdoVehicleCard);
                    } else {
                        this.ruleForm.etdoNetFlag = 0;
                    }
                }
            });
        },
        async checkCarNameNetItem (carTypeParam) {
            if (carTypeParam.length === 7) {
                carTypeParam = carTypeParam + '_2';
            } else if (carTypeParam.length === 8) {
                carTypeParam = carTypeParam + '_3';
            }
            await checkCarNameNetItemApi({ carTypeParam }).then(res => {
                if (res && +res.code === 0) {
                    if (res.data && res.data.data === 'yes') {
                        this.$message.warning('该车辆可通过北斗获取轨迹');
                        this.ruleForm.etdoNetFlag = 1;
                    } else {
                        this.$message.warning('该车辆不支持北斗轨迹获取，请要求司机全程打开直通宝');
                        this.ruleForm.etdoNetFlag = 0;
                    }
                }
            });
        },
        pageChange (val) {
            this.currentPage = val;
            this._getList(val);
        },
        sizeChange (val) {
            this.pageSize = val;
            this._getList();
        },
        // 查询结果
        searchChange (val) {
            val.receiverCode = val.receiverCode || [];
            val.eoorConsigneeCityCode = val.receiverCode[1] || '';
            val.eoorConsigneeDistrictCode = val.receiverCode[2] || '';
            delete val.receiverCode;
            val = this.formattingData(val);
            val.ettaReqDeliveryDateT = val.ettaReqDeliveryDateT ? dayjs(val.ettaReqDeliveryDateT).format('YYYY-MM-DD 23:59:59') : '';
            this.searchData = val;
            this._getList();
        },
        formattingData (data) {
            const tempData = {
                createTimeFrom: data.createTime && data.createTime.length ? dayjs(data.createTime[0]).format('YYYY-MM-DD HH:mm:ss') : '',
                createTimeTo: data.createTime && data.createTime.length ? dayjs(data.createTime[1]).format('YYYY-MM-DD HH:mm:ss') : '',
                ...data,
                ettaPersonZone: this.user.userCode.toLocaleLowerCase()
            };
            if (!this.config.searchList.searchTxt[4].options.length) {
                delete tempData.ettaPersonZone;
            }
            delete tempData.createTime;
            return tempData;
        },
        exportFile (submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            if (!this.isFirstSearch) {
                const msg = this._validateSearchParams(this.searchData);
                if (msg) return this.$message.warning(msg);
            }
            submit({ ...this.exportParams, carrierCode: this.supplier.supplierCode, tenantCode: this.currentTenant.tenantCode });
            this.isFirstSearch = false;
        },
        rowDBclick (row) {
            this._getEtTaskMaterielItem(row.ettaNo);
            this.isDetail = true;
        },
        back () {
            this.isDetail = false;
            this._getList();
        },
        handleCloseLoadTruckSortDialogVisible () {
            this.loadTruckSortDialogVisible = false;
            this.loadingSeq = 1;
        },
        loadTruckSort () {
            if (!this.selectArray.length) {
                return this.$message.error('至少选中一条数据');
            };
            this.loadTruckSortDialogVisible = true;
        },
        handleSave () {
            if (!this.loadingSeq) {
                return this.$message.error('请填写装车排序');
            };
            if (this.loadingSeq + '' === '0') {
                return this.$message.error('装车排序不能为0');
            }
            this.loadingBtn = true;
            const ettaNoList = this.selectArray.map(item => item.ettaNo);
            const param = {
                loadingSeq: this.loadingSeq + '',
                ettaNos: ettaNoList.join(',')
            };
            lspLoadingSeq(param)
                .then(res => {
                    if (res && +res.code === 0) {
                        if (res.data.success) {
                            this.$message.success('保存成功！');
                        } else {
                            this.$message.error(res.data.messagesAsString);
                        }
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loadingBtn = false;
                    this.loadTruckSortDialogVisible = false;
                    this.loadingSeq = 1;
                    this._getList();
                });
        },
        line () {
            if (!this.selectArray.length) {
                this.$message.error('请选中一条数据');
                return false;
            }
            // 是否直通宝转运 默认为否
            this.ruleForm.etdoLtlFlag = '0';
            this.prefixParams.routeNoList = this.selectArray.filter(item => item.ettaEblnCode).map(item => item.ettaEblnCode);
            this._getEtTaskItemByAssighNos();
            const param = {
                carrierCode: this.selectArray[0].ettaCarrierEbcuCode || '',
                ettaNo: this.selectArray[0].ettaNo || ''
            };
            shippingTypeData(param)
                .then(res => {
                    if (res && +res.code === 0) {
                        if (res.data.data === 0) {
                            this.ruleForm.shippingType = '';
                        }
                        if (res.data.data === 1) {
                            this.ruleForm.shippingType = '10';
                        }
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.lineVisible = true;
                });
        },
        selectChange (data) {
            this.collectEttaQuantity = 0;
            this.collectEttaVolume = 0;
            this.collectEttaWeight = 0;
            let ettaQuantity = 0;
            let ettaVolume = 0;
            let ettaWeight = 0;
            data.forEach(item => {
                ettaQuantity += item.ettaQuantity;
                ettaWeight += item.ettaWeight;
                ettaVolume += item.ettaVolume * 1000000;
            });
            this.collectEttaQuantity = ettaQuantity;
            this.collectEttaWeight = ettaWeight;
            this.collectEttaVolume = ettaVolume / 1000000;
            this.selectArray = data;
        },
        handleLineClose (req) {
            this.ruleForm = {
                etdoCarrierName: '', // 承运商名字
                etdoCarrierCode: '', // 承运商编码
                etdoLtlFlag: '', // 直通宝标识
                etdoVehicleCard: '', // 车牌号
                etdoEquipmentName: '', // 车型
                etdoMainDriver: '', // 司机
                etdoMainDriverContactWay: '', // 联系方式
                transportation: '', // 运输方式
                etdoBesArriveDate: '', // 预计到车时间
                etdoPayMethod: '',
                etdoRemark: '',
                etdoE6Devicename: '',
                shippingType: ''// 发运类型
            };
            this.$refs.form.resetFields();
            this.lineVisible = false;
            if (req) {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            }
        },
        handleLineChange () {
            this._saveEtDispatchOrder();
        },
        getSelectValue (data) {
            this.ruleForm = Object.assign({}, this.ruleForm, data);
        },
        getAdvanceValue (data) {
            this.ruleForm = Object.assign({}, this.ruleForm, data);
        }
    }
};
</script>
<style lang="less">
.dispatch {
    .dispatch-collect {
        color: red;
        font-size: 14px;
        margin: auto 8px;
    }

    .el-row {
        display: flex;
        flex-wrap: wrap;
    }
}
</style>
